"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _commonUtils = require("@sial/common-utils");
var _isomorphicDompurify = _interopRequireDefault(require("isomorphic-dompurify"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _reactSdk = require("@optimizely/react-sdk");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var RecommendedSearchConfig = {
  emptyLabel: 'Configure Recommended Search Term Component',
  isEmpty: function isEmpty(props) {
    return true;
  }
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _anchorChip, _slideNav, _slideNavSecondVersio;
  return (0, _styles.createStyles)({
    recommendedSearchWrapper: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      maxWidth: '1280px',
      margin: '0 auto'
    }),
    wrapperMinimumWidth: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      minWidth: '1280px'
    }),
    anchorChip: (_anchorChip = {
      display: 'flex',
      background: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(12),
      padding: theme.spacing(2, 4),
      borderRadius: theme.typography.pxToRem(40),
      height: theme.typography.pxToRem(32),
      lineHeight: 'normal',
      transition: 'none'
    }, (0, _defineProperty2.default)(_anchorChip, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(16),
      height: theme.typography.pxToRem(40)
    }), (0, _defineProperty2.default)(_anchorChip, '& > span', {
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.common.black,
      padding: theme.spacing(0.5),
      '& sup': {
        top: 0,
        padding: 0
      }
    }), (0, _defineProperty2.default)(_anchorChip, '&:hover', {
      borderColor: theme.palette.primary.main,
      backgroundColor: "".concat(theme.palette.primary.light, " !important"),
      '& > span': {
        color: theme.palette.primary.main
      }
    }), _anchorChip),
    slideNav: (_slideNav = {
      position: 'absolute',
      height: '100%',
      display: 'none'
    }, (0, _defineProperty2.default)(_slideNav, theme.breakpoints.up('md'), {
      display: 'inline-flex'
    }), (0, _defineProperty2.default)(_slideNav, '&[disabled]', {
      display: 'none'
    }), _slideNav),
    leftNavButton: {
      left: '-28px'
    },
    rightNavButton: {
      right: '-28px'
    },
    navArrow: {
      fontSize: theme.typography.pxToRem(28),
      color: theme.palette.secondary.main
    },
    navArrowDisabled: {
      color: theme.palette.text.disabled
    },
    scrollWrapperContainer: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      paddingBottom: theme.spacing(4),
      position: 'relative'
    }, theme.breakpoints.up('md'), {
      paddingBottom: 0
    }),
    scrollWrapper: (0, _defineProperty2.default)({
      display: 'flex',
      gap: theme.spacing(2),
      overflow: 'scroll hidden',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    }, theme.breakpoints.up('md'), {
      overflow: 'hidden'
    }),
    heading: {
      marginBottom: "".concat(theme.spacing(6), "px !important"),
      marginTop: '0 !important'
    },
    HeadingSecondVersion: {
      marginTop: '0 !important',
      fontFeatureSettings: "'liga' off",
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: theme.spacing(0.0225)
    },
    navArrowSecondVersion: {
      fontSize: theme.typography.pxToRem(28),
      color: theme.palette.primary.main
    },
    navArrowDisabledSecondVersion: {
      color: theme.palette.grey['500'],
      cursor: 'auto'
    },
    slideNavSecondVersion: (_slideNavSecondVersio = {
      position: 'absolute',
      height: '100%',
      display: 'none'
    }, (0, _defineProperty2.default)(_slideNavSecondVersio, theme.breakpoints.up('md'), {
      display: 'inline-flex'
    }), (0, _defineProperty2.default)(_slideNavSecondVersio, '&[disabled]', {
      display: 'none'
    }), _slideNavSecondVersio),
    leftNavButtonSecondVersion: {
      left: '-37px'
    },
    rightNavButtonSecondVersion: {
      right: '-37px'
    },
    scrollWrapperSecondVersion: (0, _defineProperty2.default)({
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(4),
      overflow: 'scroll hidden',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    }, theme.breakpoints.up('md'), {
      overflow: 'hidden'
    }),
    anchorChipSecondVersion: {
      borderRadius: theme.spacing(1.25),
      border: "2px solid rgba(201, 201, 201, 0.50)",
      backgroundColor: theme.palette.common.white,
      whiteSpace: 'nowrap',
      padding: theme.spacing(6, 4),
      fontFeatureSettings: "'liga' off",
      fontStyle: 'normal',
      lineHeight: "".concat(theme.spacing(4.5), "px")
    },
    scrollWrapperContainerSecondVersion: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative'
    }
  });
});
var RecommendedSearch = function RecommendedSearch(_ref) {
  var _clsx;
  var headline = _ref.headline,
    anchorId = _ref.anchorId,
    searchLinks = _ref.searchLinks,
    _ref$headingStyle = _ref.headingStyle,
    headingStyle = _ref$headingStyle === void 0 ? 'h2' : _ref$headingStyle;
  var classes = useStyles();
  var scrollWrapperRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    scrollLeft = _useState[0],
    setScrollLeft = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    optlyShowCategories = _useState2[0],
    setOptlyShowCategories = _useState2[1];
  var _useDecision = (0, _reactSdk.useDecision)('wabt-192'),
    _useDecision2 = (0, _slicedToArray2.default)(_useDecision, 1),
    decision = _useDecision2[0];

  // 'wabt-192' optly test for visual appearance of the explore categories section on L1 and L2 category pages
  // show optly version if the test is on/enabled
  (0, _react.useEffect)(function () {
    if (decision && decision.enabled) {
      setOptlyShowCategories(decision.enabled);
    }
  }, [decision]);
  var scrollEdgeLeft = scrollLeft === 0;
  var scrollEdgeRight = scrollWrapperRef.current && scrollLeft + scrollWrapperRef.current.clientWidth >= scrollWrapperRef.current.scrollWidth;
  var scrollByAmount = function scrollByAmount(amount) {
    if (scrollWrapperRef.current) {
      var _scrollWrapperRef$cur;
      scrollWrapperRef === null || scrollWrapperRef === void 0 ? void 0 : (_scrollWrapperRef$cur = scrollWrapperRef.current) === null || _scrollWrapperRef$cur === void 0 ? void 0 : _scrollWrapperRef$cur.scrollBy({
        left: amount,
        behavior: 'smooth'
      });
      setScrollLeft(function (prev) {
        return prev + amount;
      });
    }
  };
  var handlePreviousClick = function handlePreviousClick() {
    !scrollEdgeLeft && scrollByAmount(-200); // Scroll left by 200px, adjust this value as needed

    _commonUtils.Analytics.sendGTMEvent({
      eventType: _commonUtils.GTMEventTypes.AnalyticsEvent,
      payload: {
        event: 'navigation_interaction',
        action: 'carousel click',
        detail: 'left arrow',
        section: 'popular searches',
        component: 'body',
        element_type: 'icon',
        element_text: undefined,
        link_url: undefined,
        core_event: 'no',
        user_detail: undefined,
        event_group: undefined,
        event_subgroup: undefined
      }
    });
  };
  var handleNextClick = function handleNextClick() {
    !scrollEdgeRight && scrollByAmount(200); // Scroll right by 200px, adjust this value as needed

    _commonUtils.Analytics.sendGTMEvent({
      eventType: _commonUtils.GTMEventTypes.AnalyticsEvent,
      payload: {
        event: 'navigation_interaction',
        action: 'carousel click',
        detail: 'right arrow',
        section: 'popular searches',
        component: 'body',
        element_type: 'icon',
        element_text: undefined,
        link_url: undefined,
        core_event: 'no',
        user_detail: undefined,
        event_group: undefined,
        event_subgroup: undefined
      }
    });
  };
  var trackGA4SearchEvent = function trackGA4SearchEvent(label) {
    var _label$toLowerCase;
    _commonUtils.Analytics.sendGTMEvent({
      eventType: _commonUtils.GTMEventTypes.AnalyticsEvent,
      payload: {
        event: 'search',
        search_box_input: 'no_user_input',
        search_term: (_label$toLowerCase = label === null || label === void 0 ? void 0 : label.toLowerCase()) !== null && _label$toLowerCase !== void 0 ? _label$toLowerCase : '',
        search_component: headline ? headline.replace(/(<([^>]+)>)/gi, '').replace(/[^\w\s]/gi, '').toLowerCase() : 'popular searches',
        search_auto_suggest: undefined,
        search_auto_suggest_term: undefined,
        search_type: undefined,
        event_category: undefined,
        event_action: undefined,
        event_label: undefined
      }
    });
  };
  var getLabel = function getLabel(label) {
    if (!label) return '';
    var sanitizedContent = _isomorphicDompurify.default.sanitize(label);
    var parsedContent = (0, _htmlReactParser.default)(sanitizedContent);
    return parsedContent;
  };
  return __jsx(_react.default.Fragment, null, optlyShowCategories ? __jsx("div", {
    className: (0, _clsx2.default)(classes.recommendedSearchWrapper, (_clsx = {}, (0, _defineProperty2.default)(_clsx, classes.wrapperMinimumWidth, scrollEdgeRight), (0, _defineProperty2.default)(_clsx, "optlyRecommendedSearchWrapper", optlyShowCategories), _clsx))
  }, headline && __jsx(_core.Typography, {
    className: classes.HeadingSecondVersion,
    variant: headingStyle,
    dangerouslySetInnerHTML: {
      __html: headline
    }
  }), __jsx("div", {
    id: anchorId,
    className: classes.scrollWrapperContainerSecondVersion
  }, __jsx(_core.ButtonBase, {
    className: (0, _clsx2.default)(classes.leftNavButtonSecondVersion, classes.slideNavSecondVersion, scrollEdgeLeft && classes.navArrowDisabledSecondVersion),
    disabled: scrollEdgeLeft && scrollEdgeRight || false,
    "aria-label": "previous",
    onClick: handlePreviousClick
  }, __jsx(_KeyboardArrowLeft.default, {
    className: (0, _clsx2.default)(classes.navArrowSecondVersion, scrollEdgeLeft && classes.navArrowDisabledSecondVersion)
  })), __jsx("div", {
    className: classes.scrollWrapperSecondVersion,
    ref: scrollWrapperRef
  }, searchLinks && searchLinks.length > 0 && Array.isArray(searchLinks) ? searchLinks.map(function (item, idx) {
    return __jsx("a", {
      href: item === null || item === void 0 ? void 0 : item.url,
      key: "recommendedSearch-".concat(item.label, "-").concat(idx),
      className: classes.anchorChipSecondVersion,
      onClick: function onClick() {
        return trackGA4SearchEvent(item === null || item === void 0 ? void 0 : item.label);
      }
    }, getLabel(item === null || item === void 0 ? void 0 : item.label));
  }) : null), __jsx(_core.ButtonBase, {
    className: (0, _clsx2.default)(classes.rightNavButtonSecondVersion, classes.slideNavSecondVersion, scrollEdgeRight && classes.navArrowDisabledSecondVersion),
    "aria-label": "next",
    disabled: scrollEdgeLeft && scrollEdgeRight || false,
    onClick: handleNextClick
  }, __jsx(_KeyboardArrowRight.default, {
    className: (0, _clsx2.default)(classes.navArrowSecondVersion, scrollEdgeRight && classes.navArrowDisabledSecondVersion)
  })))) : __jsx("div", {
    className: (0, _clsx2.default)(classes.recommendedSearchWrapper, scrollEdgeRight && classes.wrapperMinimumWidth)
  }, headline && __jsx(_core.Typography, {
    className: classes.heading,
    variant: headingStyle,
    dangerouslySetInnerHTML: {
      __html: headline
    }
  }), __jsx("div", {
    id: anchorId,
    className: classes.scrollWrapperContainer
  }, __jsx(_core.ButtonBase, {
    className: (0, _clsx2.default)(classes.leftNavButton, classes.slideNav),
    disabled: scrollEdgeLeft,
    "aria-label": "previous",
    onClick: handlePreviousClick
  }, __jsx(_KeyboardArrowLeft.default, {
    className: (0, _clsx2.default)(classes.navArrow, scrollEdgeLeft && classes.navArrowDisabled)
  })), __jsx("div", {
    className: classes.scrollWrapper,
    ref: scrollWrapperRef
  }, searchLinks && searchLinks.length > 0 && Array.isArray(searchLinks) ? searchLinks.map(function (item, idx) {
    return __jsx(_core.Chip, {
      key: "recommendedSearch-".concat(idx),
      className: classes.anchorChip,
      label: getLabel(item === null || item === void 0 ? void 0 : item.label),
      component: "a",
      href: item === null || item === void 0 ? void 0 : item.url,
      variant: "outlined",
      clickable: true,
      onClick: function onClick() {
        return trackGA4SearchEvent(item === null || item === void 0 ? void 0 : item.label);
      }
    });
  }) : null), __jsx(_core.ButtonBase, {
    className: (0, _clsx2.default)(classes.rightNavButton, classes.slideNav),
    "aria-label": "next",
    disabled: scrollEdgeRight || false,
    onClick: handleNextClick
  }, __jsx(_KeyboardArrowRight.default, {
    className: (0, _clsx2.default)(classes.navArrow, scrollEdgeRight && classes.navArrowDisabled)
  })))));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/recommendedSearch')(RecommendedSearch, RecommendedSearchConfig);
exports.default = _default;